import { render, staticRenderFns } from "./NoOrg.vue?vue&type=template&id=86dd8056&scoped=true"
import script from "./NoOrg.vue?vue&type=script&lang=js"
export * from "./NoOrg.vue?vue&type=script&lang=js"
import style0 from "./NoOrg.vue?vue&type=style&index=0&id=86dd8056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dd8056",
  null
  
)

export default component.exports